import React from 'react';

const ConfirmationContainer: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  return <>{'Confirmation'}</>;
};

export { ConfirmationContainer };
